import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

 
const cryptoApiHeaders = {
    "cache-control": "max-age=60",
    "content-length": "58217",
    "content-type": "application/json; charset=utf-8",
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '9120775ad6mshb7baaa0bf6d1e0ap1ad137jsn5a8a10cbb3f8'    
}

const baseUrl = 'https://coinranking1.p.rapidapi.com';

const createRequest = (url) =>({url, headers: cryptoApiHeaders})

export const cryptoApi = createApi({
        reducerPath: 'cryptoApi',
        baseQuery: fetchBaseQuery({baseUrl}),
        endpoints: (builder)=>({
            getCryptos: builder.query({
                query: (count)=> createRequest(`/coins/?limit=${count}`)
            }),
            getCoin: builder.query({
                query: (coinId)=> createRequest(`/coin/${coinId}`)
            }),
            getCoinHistory: builder.query({
                query: ({coinId,timePeriod})=> createRequest(`/coin/${coinId}/history?timePeriod=${timePeriod}`)
            }),
            getCoinExchanges: builder.query({
                query: ()=> createRequest(`/exchanges`)
            })
        })
    }
)

export const {
    useGetCryptosQuery, useGetCoinQuery, useGetCoinHistoryQuery,useGetCoinExchangesQuery
} = cryptoApi;



// var options = {0
//     method: 'GET',
//     url: 'https://coinranking1.p.rapidapi.com/coins',
//     params: {
//       referenceCurrencyUuid: 'yhjMzLPhuIDl',
//       timePeriod: '24h',
//       tiers: '1',
//       orderBy: 'marketCap',
//       orderDirection: 'desc',
//       limit: '50',
//       offset: '0'
//     },
//     headers: {
//       'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
//       'x-rapidapi-key': '9120775ad6mshb7baaa0bf6d1e0ap1ad137jsn5a8a10cbb3f8'
//     }
//   };